import { getAttribute } from 'core/utils/card';

function getPriorityResponseCount(priorities, card) {
  const allDataSources = getAttribute(card, 'allDataSources') || false;
  const dataSources = getAttribute(card, 'dataSources') || [];
  const dataSourceKeys = dataSources.map((d) => d.key.toString());

  return priorities
    .filter(
      (p) =>
        allDataSources || dataSourceKeys.includes(p.measurement.key.toString())
    )
    .reduce((sum, p) => sum + (p.data.ncount || 0), 0);
}

export function getCardResponseCount(data, card) {
  // priority data is only requested once then filtered client-side, hence
  // logic for response count needs handled client-side.

  return data.priorities
    ? getPriorityResponseCount(data.priorities, card)
    : data.totalCount;
}

export function isCardDataEmpty(cardData) {
  return (
    cardData === null ||
    cardData === undefined ||
    Object.keys(cardData).length <= 1
  );
}
